import React from "react";

import { Regular } from "../regular";
import { useElementAppearsOnScreen } from "../../../../hooks/use-element-on-screen";
import { useSnowplowContext } from "../../../../analytics/snowplow";

export type ImageArticleType = {
    type: "imageNewsEntry";
    categories: { color: string; title: string }[];
    external: boolean;
    id: string;
    index: number;
    lang: string;
    listingSize: string;
    postDate: number;
    newUntil: number;
    section: "newsEntries" | "esportNewsEntries" | "communityEntries";
    thumbnail: ImageSourceSets;
    thumbnailAlt: ImageSourceSets;
    title: string;
    url: string;
};

export const ImageArticle = (props: ImageArticleType) => {
    const [ref, isVisible] = useElementAppearsOnScreen<HTMLDivElement>();
    const { trackImpression } = useSnowplowContext();

    React.useEffect(() => {
        if (isVisible) {
            trackImpression(props.id, props.title);
        }
    }, [props.id, isVisible]);

    return (
        <div ref={ref} className="article-image">
            <Regular {...props} external={true} ctaHidden={!props.url} />
        </div>
    );
};
